import { useEffect, useLayoutEffect } from "react";
import { useBreadcrumbs } from "../../context/breadcrumb/breadcrumb-context.tsx";
const RouteWrapper = ({ meta, setPageMeta, children }: any) => {
  const { setBreadcrumbs } = useBreadcrumbs(); 
useLayoutEffect(() => {         
    setBreadcrumbs([]);       
  }, [meta.title]);


  useEffect(() => {
    setPageMeta(meta);            
  }, [meta.title, meta.description, meta.isHome]);

  return children;  
};

export default RouteWrapper;
